export function validateChecklistTemplate({
  formData,
  segments,
  segmentData,
  resources,
}) {
  const errors = [];

  // Validate top-level form data
  if (!formData.description?.trim()) {
    errors.push(resources["InvalidDescription"] ?? "Invalid description.");
  }
  
  if (!formData.validFrom) {
    errors.push(resources["ValidFromIsRequired"] ?? "ValidFrom is required.");
  }
  
  if (formData.validFrom && formData.validTill && formData.validTill < formData.validFrom) {
    errors.push(
      resources["ValidTillMustBeAfterValidFrom"] ??
        "ValidTill must be after ValidFrom."
    );
  }

  const segmentIds = Object.keys(segments);

  for (const segId of segmentIds) {
    const segMeta = segmentData[segId] || {};
    const segDescription = segMeta.description?.trim() ?? "";
    const itemIds = segments[segId] || [];

    if (!segDescription) {
      errors.push(resources["SegmentIsMissingADescription"]);
    }

    if (itemIds.length === 0) {
      errors.push(resources["SegmentShouldHaveAtLeastOneItem"]);

      // Skip item checks if no items exist
      continue;
    }

    // Validate each
    for (const itemId of itemIds) {
      const itemMeta = segMeta.items?.[itemId] || {};

      const shortDesc = itemMeta.shortDescription?.trim() ?? "";
      const longDesc = itemMeta.longDescription?.trim() ?? "";
      const respType = itemMeta.responseType ?? 0;

      if (!shortDesc) {
        errors.push(resources["ItemIsMissingAShortDescription"]);
      }
      if (!longDesc) {
        errors.push(resources["ItemIsMissingALongDescription"]);
      }
      if (respType === 0) {
        errors.push(resources["ItemMustHaveAValidResponseType"]);
      }
    }
  }

  return errors;
}
